"use client";
import { useEffect } from "react";
import { useSessionStore } from "@/lib/sessionStore";

const EYE_EXERCISES = [
  "👀 看向遠處 — 盯著 6 公尺外的物體 20 秒",
  "💧 喝一杯水，補充水分",
  "🧘 閉上眼睛，深呼吸 3 次",
  "🙆 站起來伸展手臂和肩膀",
  "🌟 告訴自己：我今天學了新的中文！",
];

export default function BreakOverlay() {
  const { isOnBreak, breakSecondsLeft, breakSettings, tickBreakSecond, endBreak } =
    useSessionStore();

  useEffect(() => {
    if (!isOnBreak) return;
    const interval = setInterval(tickBreakSecond, 1000);
    return () => clearInterval(interval);
  }, [isOnBreak, tickBreakSecond]);

  if (!isOnBreak) return null;

  const mins = Math.floor(breakSecondsLeft / 60);
  const secs = breakSecondsLeft % 60;
  const progress = 1 - breakSecondsLeft / (breakSettings.breakMinutes * 60);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-gradient-to-br from-blue-900 to-indigo-900">
      <div className="max-w-lg w-full mx-4 text-center">

        {/* Eye icon animated */}
        <div className="text-8xl mb-6 animate-pulse">👁️</div>

        <h1 className="text-4xl font-bold text-white mb-2">眼睛休息時間</h1>
        <p className="text-blue-200 text-lg mb-8">Eye Break — 保護你的眼睛！</p>

        {/* Countdown */}
        <div className="text-7xl font-mono font-bold text-yellow-400 mb-6">
          {String(mins).padStart(2, "0")}:{String(secs).padStart(2, "0")}
        </div>

        {/* Progress bar */}
        <div className="w-full bg-blue-800 rounded-full h-3 mb-8">
          <div
            className="bg-yellow-400 h-3 rounded-full transition-all duration-1000"
            style={{ width: `${progress * 100}%` }}
          />
        </div>

        {/* Activities */}
        <div className="bg-blue-800/50 rounded-2xl p-6 mb-6 text-left space-y-3">
          <p className="text-blue-200 text-sm font-semibold uppercase tracking-wide mb-3">
            休息時可以做：
          </p>
          {EYE_EXERCISES.map((ex, i) => (
            <p key={i} className="text-white text-base">{ex}</p>
          ))}
        </div>

        {/* Skip button (only after 50% done) */}
        {progress >= 0.5 && (
          <button
            onClick={endBreak}
            className="text-blue-400 text-sm underline hover:text-blue-200 transition"
          >
            提早結束休息（需要家長允許）
          </button>
        )}

        <p className="text-blue-400 text-xs mt-4">
          休息時間不計入課程點數
        </p>
      </div>
    </div>
  );
}
